"use strict";
exports.__esModule = true;
exports.ShiftRule = exports.ShiftNoteType = void 0;
var ShiftNoteType;
(function (ShiftNoteType) {
    ShiftNoteType["ShiftForm"] = "ShiftForm";
    ShiftNoteType["ShiftNote"] = "ShiftNote";
    ShiftNoteType["ShiftPhoto"] = "ShiftPhoto";
    ShiftNoteType["ShiftSignature"] = "ShiftSignature";
})(ShiftNoteType = exports.ShiftNoteType || (exports.ShiftNoteType = {}));
var ShiftRule;
(function (ShiftRule) {
    ShiftRule[ShiftRule["unknown"] = -1] = "unknown";
    ShiftRule[ShiftRule["start_shift"] = 0] = "start_shift";
    ShiftRule[ShiftRule["end_shift"] = 1] = "end_shift";
})(ShiftRule = exports.ShiftRule || (exports.ShiftRule = {}));
//# sourceMappingURL=shift.js.map